import { render, staticRenderFns } from "./UserModalEdit.vue?vue&type=template&id=1b8a655a&scoped=true&"
import script from "./UserModalEdit.vue?vue&type=script&lang=js&"
export * from "./UserModalEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserModalEdit.vue?vue&type=style&index=0&id=1b8a655a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a655a",
  null
  
)

export default component.exports